<template>
  <div>
    <div
      class="block-group"
      :class="[
        inline ? '_inline' : '',
        close ? '_close' : ''
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.block-group {
  display: flex;
  width: calc(100% - 10px);
  margin: 4px;
  // border-bottom: 1px solid #e2e2e2;
  & .blocks {
    margin: 5px 5px 10px;
  }

  &._inline {
    display: inline-flex !important;
    justify-content: flex-start;
  }

  &._close {
    margin: 0 !important;

    & .blocks {
      margin: 0 !important;
    }
  }
}
</style>
